import { portfolioButtonStyles } from '../../../../styles';

const styles = theme => ({
  ...portfolioButtonStyles(theme),
  root: {
    width: 'max-content',
    height: 'max-content',
  },
});

export default styles;
